module.exports = __webpack_public_path__ + "img/34.817afbea.svg";